import { RouteFactory } from "@app/routePaths";
import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import SeoFooter from "@components/Footer/SeoFooter/SeoFooter";
import { GADataProps } from "@components/GAData/GAData";
import Header from "@components/Header/Header";
import PulseEntry from "@features/pulse/components/PulseEntry/PulseEntry";
import { useInjectClientData } from "@hooks/useInjectClientData";
import { useMostReadArticleList } from "@hooks/useMostReadArticleList";
import KeywordStoriesRow from "@routes/Section/components/VerticalMeta/KeywordStoriesRow";
import LatestStoriesRow from "@routes/Section/components/VerticalMeta/LatestStoriesRow";
import TopStoriesRow from "@routes/Section/components/VerticalMeta/TopStoriesRow";
import SMEBanner from "@routes/Section/layouts/Verticals/SME/components/SMEBanner";
import { VerticalsSectionPageData } from "@routes/Section/utils/types";

const SMEVertical = ({
  topStories,
  additional,
  seoFooterData,
  gaProps,
}: VerticalsSectionPageData & { gaProps: GADataProps }): React.ReactElement => {
  const mostReadArticles = useMostReadArticleList();

  useInjectClientData({ gaProps });

  return (
    <div className="w-full" data-testid="sme-vertical-component">
      <Ad
        adType="lb1"
        className="flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />

      <Header />

      <PulseEntry />

      <Container>
        <SMEBanner className="my-6" />

        <TopStoriesRow articles={topStories} verticalName="sme" />

        <LatestStoriesRow
          articles={topStories.slice(4, 9)}
          seeMoreLink={`${RouteFactory.sgsme}/latest`}
          verticalName="sme"
          mostReadStories={mostReadArticles}
        />

        <KeywordStoriesRow
          seeMoreLink={RouteFactory.keywords("singapore-smes")}
          data={additional?.[0]}
          verticalName="sme"
          verticalBlockTitle="SINGAPORE SMES"
        />
      </Container>

      <SeoFooter data={seoFooterData} />

      <Ad adType="catfish" />
      <Ad adType="prestitial" />
    </div>
  );
};

export default SMEVertical;
